import React, { useState } from 'react';
import { AppBar, Drawer, DrawerHeader } from './components';
import Toolbar from '@mui/material/Toolbar';
import { Avatar, Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { RootState } from '../../../redux/store';
import { typesRedux } from '../../../shared/types/typesRedux';
import { AuthMessages } from '../../../shared/messages/authMessages';
import { useAuthContext } from '../../../contexts/authContext';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import Sidebar from './sidebar';
import variables from '../../../shared/styles/settings.module.scss';
import { useNavigate } from 'react-router-dom';
import { SIGNIN } from '../../../routes/paths';
import Icon from '../../../assets/images/logos/avatar.png';
import ProfileImageModal from '../profileModal';
import { useTheme } from '@mui/material/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
interface Option {
    route?: string | undefined;
    label: string;
    icon: JSX.Element | string;
    subItems?: any[];
    permissions?: any[];
}

type Props = {
    modules: Option[];
    hideTopBar?: boolean;
};

function NavBar({ modules, hideTopBar = false }: Props) {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { logout, modeTheme } = useAuthContext();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { name, surname, type, profile_image } = logUser || {};
    const [open, setOpen] = useState<boolean>(false);
    const [manualOpen, setManualOpen] = useState<boolean>(false);
    const [isOpenProfileImageModal, setIsProfileImageModal] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const { TITLE_LOGOUT, MESSAGE_LOGOUT } = AuthMessages.logout;
    const theme = useTheme();

    const handleDrawerOpen = () => {
        setOpen(true);
        setManualOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
        setManualOpen(false);
    };

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const modeThemeClick = () => {
        handleClose();
        dispatch({
            type: typesRedux.MODE_THEME,
            payload: modeTheme === 'darkMode' ? 'lightMode' : 'darkMode',
        });
    };

    const logoutClick = () => {
        handleClose();
        Swal.fire({
            title: TITLE_LOGOUT,
            text: MESSAGE_LOGOUT,
            icon: 'question',
            iconColor:
                modeTheme === 'darkMode'
                    ? variables.darkColor
                    : variables.primaryColor,
            showCancelButton: true,
            cancelButtonText: 'NO',
            allowOutsideClick: false,
            cancelButtonColor:
                modeTheme === 'darkMode'
                    ? variables.darkColor
                    : variables.primaryColor,
            confirmButtonText: 'SI',
            confirmButtonColor:
                modeTheme === 'darkMode'
                    ? variables.darkColor
                    : variables.primaryColor,
            customClass: {
                container: 'swal_wide_class',
            },
        }).then((response) => {
            if (response.isConfirmed) {
                logout();
                dispatch({
                    type: typesRedux.LOGOUT_LOGIN,
                    payload: '',
                });
                navigate(SIGNIN);
            }
        });
    };

    const validatePermission = (permissions: any) => {
        const data = permissions?.find((p: any) => p === type);
        return data !== undefined;
    };

    return (
        <>
            {!hideTopBar && (
                <AppBar
                    position="fixed"
                    open={open}
                    sx={{
                        width: '100%',
                        height: '80px',
                        backgroundColor: theme.palette.common.white,
                        color: theme.palette.text.primary,
                        zIndex: theme.zIndex.drawer + 1,
                    }}
                >
                    <Toolbar>
                        <Box
                            component="img"
                            src={require('../../../assets/images/logos/logo.png')}
                            sx={{
                                width: '180px',
                                height: '65px',
                                objectFit: 'contain',
                            }}
                            alt="logo"
                        />
                        <Box component="div" flexGrow={1} />
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    flexWrap: 'nowrap',
                                }}
                            >
                                <Typography
                                    component="div"
                                    sx={{
                                        flexGrow: 1,
                                        mr: 1,
                                        fontSize: { lg: 15, md: 12.5, xs: 10 },
                                        textDecoration: 'none',
                                        textTransform: 'uppercase',
                                        color: 'primary.main',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    ¡Hola,{' '}
                                    <strong>
                                        {name !== undefined
                                            ? name + ' ' + (surname ?? '')
                                            : 'Username'}
                                    </strong>
                                    !
                                </Typography>
                                <Avatar
                                    src={profile_image || Icon}
                                    alt="WarePilot"
                                    sx={{ width: 32, height: 32 }}
                                />
                                <Typography
                                    component="div"
                                    sx={{
                                        flexGrow: 1,
                                        ml: 1,
                                        fontSize: { lg: 15, md: 12.5, xs: 10 },
                                        textDecoration: 'none',
                                        textTransform: 'uppercase',
                                        color: 'primary.main',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {type || 'Rol'}
                                </Typography>
                            </Box>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                <KeyboardArrowDownIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem
                                    onClick={() => setIsProfileImageModal(true)}
                                    sx={{ color: 'primary.main' }}
                                >
                                    Foto de perfil
                                </MenuItem>
                                <MenuItem
                                    onClick={modeThemeClick}
                                    sx={{ color: 'primary.main' }}
                                >
                                    {modeTheme === 'darkMode'
                                        ? 'Modo Claro'
                                        : 'Modo Oscuro'}
                                </MenuItem>
                                <MenuItem
                                    onClick={logoutClick}
                                    sx={{ color: 'primary.main' }}
                                >
                                    Cerrar Sesión
                                </MenuItem>
                            </Menu>
                        </div>
                    </Toolbar>
                </AppBar>
            )}
            <ClickAwayListener
                mouseEvent="onMouseDown"
                touchEvent="onTouchStart"
                onClickAway={() => open && handleDrawerClose()}
            >
                <Drawer
                    variant="permanent"
                    open={open}
                    hideTopBar={hideTopBar}
                    onClose={(_, reason) => reason === 'backdropClick'}
                >
                    <DrawerHeader>
                        {!open ? (
                            <IconButton onClick={handleDrawerOpen}>
                                <MenuIcon
                                    sx={{ color: 'common.contrastText' }}
                                />
                            </IconButton>
                        ) : (
                            <IconButton onClick={handleDrawerClose}>
                                <CloseIcon
                                    sx={{
                                        color: 'common.contrastText',
                                        fontSize: 30,
                                    }}
                                />
                                <Typography
                                    component="h1"
                                    variant="h5"
                                    sx={{
                                        color: 'common.contrastText',
                                    }}
                                >
                                    Menú
                                </Typography>
                            </IconButton>
                        )}
                    </DrawerHeader>
                    <Divider />
                    <List
                        onMouseEnter={() => {
                            if (!manualOpen) setOpen(true);
                        }}
                        onMouseLeave={() => {
                            if (!manualOpen) setOpen(false);
                        }}
                    >
                        {modules.map(
                            (
                                { route, label, icon, subItems, permissions },
                                i
                            ) => (
                                <div key={i}>
                                    {(!permissions ||
                                        validatePermission(permissions)) && (
                                        <Sidebar
                                            route={route}
                                            label={label}
                                            icon={icon}
                                            subItems={subItems}
                                            open={open}
                                            type={type}
                                        />
                                    )}
                                </div>
                            )
                        )}
                    </List>
                </Drawer>
            </ClickAwayListener>
            <ProfileImageModal
                isOpen={isOpenProfileImageModal}
                setIsOpen={setIsProfileImageModal}
                onClose={() => setIsProfileImageModal(false)}
            />
        </>
    );
}

export default NavBar;
